import API from '../axios/API';
import * as types from '../../reduxStore/types/orders';

export const getLiveOrders = (page = 1, perPage = 10) => {
    return async (dispatch, getState) => {
        let liveOrderResponse;
        let { orders } = getState();
        let orderState = orders.currentOrderState;
        let orderingMode = orders.currentOrderingMode;
        let selectedOrderId = orders.selectedOrderId;

        // Ensure page is always a number
        const pageNumber = typeof page === 'number' ? page : 1;
        const perPageNumber = typeof perPage === 'number' ? perPage : 10;

        try {
            liveOrderResponse = await API.get(
                `${process.env.REACT_APP_BASE_URL_V3}/restaurants/:restaurantId/orders?ordering_mode=${orderingMode}&status=${orderState}&page=${pageNumber}&per_page=${perPageNumber}`
            );

            const ordersData = liveOrderResponse.orders?.data || [];
            const filteredOrder = ordersData.filter((data) => data.order_id === selectedOrderId);

            if (filteredOrder.length < 1 && ordersData?.length) {
                dispatch({
                    type: types.SET_SELECTED_ORDER,
                    payload: ordersData[0].order_id,
                });
            }

            if (!ordersData?.length) {
                dispatch({
                    type: types.SET_SELECTED_ORDER,
                    payload: '',
                });
                dispatch({
                    type: types.SET_SELECTED_ORDER_DETAILS,
                    payload: {},
                });
            }

            dispatch({
                type: types.SET_LIVE_ORDERS,
                payload: ordersData,
            });

            dispatch({
                type: types.SET_ORDERS_COUNT,
                payload: {
                    all: parseInt(liveOrderResponse.all_order_count),
                    placed: parseInt(liveOrderResponse.new_order_count),
                    restaurant_accepted: parseInt(liveOrderResponse.preparing_order_count),
                    restaurant_ready: parseInt(liveOrderResponse.ready_order_count),
                    rider_picked_up: parseInt(liveOrderResponse.dispatched_order_count),
                },
            });

            // Dispatch pagination data from the orders object
            if (liveOrderResponse.orders) {
                dispatch({
                    type: types.SET_LIVE_ORDERS_PAGINATION,
                    payload: {
                        currentPage: liveOrderResponse.orders.current_page || page,
                        totalPages: liveOrderResponse.orders.last_page || 0,
                        totalCount: liveOrderResponse.orders.total || 0,
                        perPage: liveOrderResponse.orders.per_page || perPage,
                    },
                });
            }
        } catch (error) {
            liveOrderResponse = error;
        }

        return liveOrderResponse;
    };
};

// Silent background sync — refreshes list data and counts without resetting
// selection or detail panel. Used after status changes for smooth UI updates.
export const silentSyncLiveOrders = () => {
    return async (dispatch, getState) => {
        const { orders } = getState();
        const page = orders.liveOrdersPagination.currentPage;
        const perPage = orders.liveOrdersPagination.perPage;
        const orderState = orders.currentOrderState;
        const orderingMode = orders.currentOrderingMode;

        try {
            const response = await API.get(
                `${process.env.REACT_APP_BASE_URL_V3}/restaurants/:restaurantId/orders?ordering_mode=${orderingMode}&status=${orderState}&page=${page}&per_page=${perPage}`
            );

            const ordersData = response.orders?.data || [];

            dispatch({ type: types.SET_LIVE_ORDERS, payload: ordersData });

            dispatch({
                type: types.SET_ORDERS_COUNT,
                payload: {
                    all: parseInt(response.all_order_count),
                    placed: parseInt(response.new_order_count),
                    restaurant_accepted: parseInt(response.preparing_order_count),
                    restaurant_ready: parseInt(response.ready_order_count),
                    rider_picked_up: parseInt(response.dispatched_order_count),
                },
            });

            if (response.orders) {
                dispatch({
                    type: types.SET_LIVE_ORDERS_PAGINATION,
                    payload: {
                        currentPage: response.orders.current_page || page,
                        totalPages: response.orders.last_page || 0,
                        totalCount: response.orders.total || 0,
                        perPage: response.orders.per_page || perPage,
                    },
                });
            }
        } catch (error) {
            // Silent failure — optimistic update already applied
        }
    };
};

export const resetLiveOrdersPagination = () => {
    return {
        type: types.SET_LIVE_ORDERS_PAGINATION,
        payload: {
            currentPage: 1,
            totalPages: 0,
            totalCount: 0,
            perPage: 10,
        },
    };
};
